export default "__VITE_ASSET__L360pP_Z__"